/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useCallback } from 'react';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  TextField,
  Typography,
  useMediaQuery,
  Paper
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import axios from 'axios';
import moment from 'moment';
import Draggable from 'react-draggable';
import { useParams } from 'react-router-dom';

import Button from 'components/Button/button';
import CommonAlert from 'components/CommonAlert/CommonAlert';
import PageTitleAndFilter from 'components/PageTitleAndFilter';
import CloseIconNavy from 'images/icons/signals/closesAndCancels/closeTransparent.svg';
import TrashIcon from 'images/icons/signals/removesAndDeletes/trashIconSecondary.svg';
import DeleteIconMobile from 'images/icons/signals/removesAndDeletes/trashWhiteGrayBgRoundedBorderLightBlue.svg'
import Environments from 'utils/environments';
import {
  getFilterOptions,
  handleFilterOptions
} from 'utils/handleFilterActions';


function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-confirm-title"
      cancel='[class*="MuiDialogContent-root"]'
    >
      <Paper {...props} />
    </Draggable>
  );
}

function WriteOffReleases({
  open,
  userInfo,
  handleClose,
  defaultProducts = []
}) {
  const environments = Environments(process.env.REACT_APP_ENV);
  const items = JSON.parse(localStorage.getItem('token'));
  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const isDesktopScreen = useMediaQuery('(min-width:1281px)');
  
  const profileType = items.data.profile[0][0].name;
  const { id: paramsID } = useParams();
  const [debounceTimeList, setDebounceTimeList] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [optionsDiscard, setOptionsDiscard] = useState([]);
  const [message, setMessage] = useState();
  const [statusCode, setStatusCode] = useState()
  const [severity, setSeverity] = useState()
  const [showAlert, setShowAlert] = useState(false);
  const [products, setProducts] = useState(defaultProducts);
  const [selectedProduct, setSelectedProduct] = useState();
  const [selectedProductInputValue, setSelectedProductInputValue] = useState();
  const [callSettings, setCallSettings] = useState({
    getId: paramsID,
    page: 1,
    totalPages: 0,
    size: 200,
    loading: false
  });
  const { getId, page } = callSettings;
  const [filters, setFilters] = useState([
    {
      param: 'originId',
      value: `${profileType !== 'admin' ? paramsID : ''}`,
      urlParam: `originId=${profileType !== 'admin' ? paramsID : ''}`
    },
    {
      param: 'page',
      value: 1,
      urlParam: `page=1`
    },
    {
      param: 'size',
      value: 100,
      urlParam: `size=100`
    },
    {
      param: 'date',
      value: moment(),
    },
  ]);

  const [filtersChanged, setFiltersChanged] = useState(
    filters.filter((el) => el)
  );
  const [filterFields, setFilterFields] = useState([
    [
      {
        label: !isDesktopScreen ? 'DATA' : 'Data',
        type: 'dateInputField',
        filterName: 'date',
        size: 'small_to_medium',
        initialDate: moment(),
        maxDate: moment()
      },
    ],
  ]);

  const getProducts = useCallback(
    (query = '') => {
      (async () => {
        const response = await fetch(
          `${environments.catalog}/products?page=1&size=10&originId=${paramsID}&useOnCards=true&description=${query}`
        );
        const jsonProducts = await response.json();
        setProductOptions(jsonProducts.content);
      })();
    },
    [environments.catalogV2, paramsID]
  );

  const getOptionsDiscard = useCallback(() => {
    (async () => {
      await axios
        .get(
          `${environments.catalog}/discards?type=PRODUCT&size=1000&page=1&originId=${paramsID}`
        )
        .then((response) => {
          const jsonOptionsDiscard = response.data.content;
          setOptionsDiscard(jsonOptionsDiscard);
        })
        .catch((error) => {
          console.log(error);
        });
    })();
    }, [environments.catalogV2, paramsID]
  );

  const handleFilter = (param, value) => {
    handleFilterOptions(
      param,
      value,
      filtersChanged,
      setFiltersChanged,
      null,
      true,
      '1'
    );
  };

  const getFilterHandle = (urlPath, label, key, optionReference) => {
    getFilterOptions(
      urlPath,
      label,
      key,
      filterFields,
      setFilterFields,
      optionReference,
      paramsID,
      filtersChanged,
      page,
      true
    );
  };

  const getMoreOptions = (value) => {
    debounceTimeList.forEach((el) => clearTimeout(el));

    const newTimer = setTimeout(() => {
      getProducts(value);
    }, 1500);

    setDebounceTimeList([...debounceTimeList, newTimer]);
  };

  const config = {
    headers: {
      User: `${userLocal?.user}`
    }
  };

  const handleSubmit = () => {
    setCallSettings({ ...callSettings, loading: true });

    const dateFilter = filtersChanged?.find(el => el?.param === 'date')?.value

    const body = products?.map(product => (
      {
        user: userInfo?.user,
        id: product?.id,
        typeEvent: product?.typeEvent,
        cost: product?.lastCost,
        lastCost: product?.lastCost,
        averageCost: product?.averageCost,
        originId: paramsID,
        quantity: product?.quantity,
        eventDate: moment(dateFilter).format('YYYY-MM-DD'),
        un: product?.consumptionUnitsPrimary?.abbreviation,
        lossPercentage: product?.lossPercentage,
        isVirtual: false,
        discardId: product?.discard?.discardId
      }
    ));

    axios
      .post(`${environments.catalog}/extracts?createSync=true`, body, config)
      .then((response) => {
        setStatusCode(response?.status)
        setSeverity('success')
        setMessage("Lançamentos realizados com sucesso");
        setShowAlert(true)
        setCallSettings({ ...callSettings, loading: false });
      })
      .catch((error) => {
        setStatusCode(error?.response?.status)
        setMessage(error?.response?.data?.message);
        setSeverity(null)
        setShowAlert(true)
        setCallSettings({ ...callSettings, loading: false });
        console.log(error);
      });
  };

  useEffect(() => {
    getProducts();
    getOptionsDiscard();
  }, [paramsID]);

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={() => handleClose()}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      className="defaultModal writeOffReleasesDialog"
      transitionDuration={0}
    >
      <DialogTitle
        className="modalHeader bold textAlignCenter cursorMove"
        id="draggable-dialog-title"
      >
        <Typography>
          LANÇAMENTO DE BAIXAS
        </Typography>

        <IconButton edge="start" color="inherit" onClick={() => handleClose()}>
          <img
            style={{ width: '16px', height: '16px' }}
            src={CloseIconNavy}
            alt="CloseIconNavy"
          />
        </IconButton>
      </DialogTitle>

      <DialogContent className="modalContent">
        <PageTitleAndFilter
          title=""
          activeFilterFilds={filterFields}
          handleFilter={handleFilter}
          getFilterhandle={getFilterHandle}
          dynamicJustifyOff
        />

        <table
          className="desktop quoteSolicitationsTable"
          width="100%"
          cellPadding="0"
          cellSpacing="0"
          border="0"
        >
          <thead>
            <tr className="headerTitle">
              <th width={!isDesktopScreen ? "34%" : "35%"} className="subtitle pl12 pr0 pt0 pb0">
                PRODUTO
              </th>

              <th width={!isDesktopScreen ? "12%" : "10%"} className={`subtitle right pl12 ${!isDesktopScreen ? 'pr12' : 'pr0'} pt0 pb0`}>
                QTDE
              </th>

              <th width={!isDesktopScreen ? "4%" : "3%"} className="subtitle center pl0 pr0 pt0 pb0">
                UN.
              </th>

              <th width="23%" className="subtitle pl12 pr0 pt0 pb0">
                &nbsp;
              </th>

              <th width={!isDesktopScreen ? "23%" : "27%"} className="subtitle pl12 pr0 pt0 pb0">
                TIPO
              </th>

              <th width={!isDesktopScreen ? "4%" : "2%"} className="subtitle pl0 pr0 pt0 pb0">
                &nbsp;
              </th>
            </tr>
          </thead>

          {status.loading && (
            <tr>
              <th colSpan="1" className="m10 textAlignCenter">
                <LinearProgress
                  style={{ height: '7px' }}
                  id="loading"
                  variant="query"
                />
              </th>
            </tr>
          )}

          <tbody>
            {products?.length ? (
              <>
                {products.map((product, productIndex) => {
                  const isLastElement = productIndex === products?.length - 1;

                  return (
                    <>
                      <tr>
                        <td
                          id={`description${productIndex}`}
                          className="description pl12 pr0 pt0 pb0"
                          style={{ verticalAlign: 'top' }}
                        >
                          <Autocomplete
                            options={productOptions}
                            getOptionLabel={(option) => option?.description}
                            className="autocompleteSmall mr12"
                            onInputChange={(_, value) => {
                              getMoreOptions(value);
                            }}
                            onFocus={() => {
                              getMoreOptions()
                            }}
                            onChange={(_, value) => {
                              if (value) {
                                setProducts((prevItems) =>
                                  prevItems.map((item, index) =>
                                    index === productIndex ? {
                                      ...value,
                                      quantity: product?.quantity,
                                      typeEvent: product?.typeEvent,
                                      discard: product?.discard
                                    } : item
                                  )
                                );
                              }
                            }}
                            value={product}
                            getOptionDisabled={(option) => 
                              products?.map(el => el?.id).includes(option?.id)
                            }
                            size="small"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                id={params.id}
                                type="text"
                                name="Products"
                                variant="outlined"
                                placeholder="Selecione..."
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                            )}
                            renderOption={(params) => (
                              <Typography style={{ fontSize: '12px', fontFamily: 'Lato' }}>
                                {params.description}
                              </Typography>
                            )}
                          />
                        </td>

                        <td
                          id={`quantity${productIndex}`}
                          className="description quantityField pl10 pr0 pt0 pb3 right"
                          style={{ 
                            verticalAlign: 'top', 
                            borderLeft: '1px solid #D0D3E2',
                            background: !isDesktopScreen ? '#D2D3D7' : '#FFF', 
                          }}
                        >
                          <CurrencyTextField
                            variant="outlined"
                            size="small"
                            currencySymbol=""
                            minimumValue="0"
                            outputFormat="string"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            decimalPlaces={3}
                            decimalPlacesShownOnFocus={3}
                            type="text"
                            required
                            name="quantity"
                            value={product?.quantity || ''}
                            fullWidth
                            className="textFieldSmall right"
                            placeholder="Qtde..."
                            onBlur={(e) => {
                              setProducts(products?.map(el => {
                                if (el?.id === product?.id) {
                                  return {
                                    ...el,
                                    quantity: e?.target?.value
                                  }
                                }

                                return {
                                  ...el
                                }
                              }))
                            }}
                            InputProps={{
                              style: { fontFamily: 'Lato', fontSize: '12px' }
                            }}
                          />
                        </td>

                        <td
                          id={`unity${productIndex}`}
                          className="description center pl0 pr0 pt0 pb0"
                        >
                          {product?.consumptionUnitsPrimary?.abbreviation}
                        </td>

                        <td
                          id={`status${productIndex}`}
                          className="description pl12 pr12 pt0 pb0"
                          style={{  
                            borderLeft: '1px solid #D0D3E2'
                          }}
                        >
                          <div className="dFlex">
                            <div 
                              className={`defaultStatusChip discardChip ${product?.typeEvent === 'DISCARD' && 'active'}`}
                              onClick={() => {
                                setProducts(products?.map(el => {
                                  if (el?.id === product?.id) {
                                    return {
                                      ...el,
                                      typeEvent: "DISCARD"
                                    }
                                  }

                                  return {
                                    ...el
                                  }
                                }))
                              }}
                            >
                              <span>
                                DESCARTE
                              </span>
                            </div>

                            <div 
                              className={`defaultStatusChip consumeChip ${product?.typeEvent === 'CONSUMED' && 'active'}`}
                              onClick={() => {
                                setProducts(products?.map(el => {
                                  if (el?.id === product?.id) {
                                    return {
                                      ...el,
                                      typeEvent: "CONSUMED"
                                    }
                                  }

                                  return {
                                    ...el
                                  }
                                }))
                              }}
                            >
                              <span>
                                CONSUMO
                              </span>
                            </div>
                          </div>
                        </td>

                        <td
                          id={`type${productIndex}`}
                          className="description pl12 pr12 pt0 pb0 typeField"
                          style={{  
                            borderLeft: '1px solid #D0D3E2'
                          }}
                        >
                          <Autocomplete
                            size="small"
                            onChange={(_, value) => {
                              setProducts(products?.map(el => {
                                if (el?.id === product?.id) {
                                  return {
                                    ...el,
                                    discard: {
                                      ...value,
                                      discardId: value?.id
                                    }
                                  }
                                }

                                return {
                                  ...el
                                }
                              }))
                            }}
                            getOptionLabel={(option) => option.description}
                            options={optionsDiscard}
                            value={product?.discard}
                            className="autocompleteSmall"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                id={params.id}
                                type="text"
                                name="discardType"
                                variant="outlined"
                                required
                                placeholder="PRODUTOS..."
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                            )}
                            renderOption={(params) => (
                              <Typography
                                style={{
                                  fontSize: '12px',
                                  fontFamily: 'Lato'
                                }}
                              >
                                {params.description}
                              </Typography>
                            )}
                          />
                        </td>

                        <td
                          id={`delete${productIndex}`}
                          className="description pl0 pr0 center"
                          style={{  
                            borderLeft: '1px solid #D0D3E2'
                          }}
                        >
                          <IconButton
                            aria-label="delete"
                            onClick={() => {
                              setProducts(products?.filter(
                                (_, index) => index !== productIndex
                              ))
                            }}
                            style={{ padding: 0, outline: 0 }}
                          >
                            <img 
                              style={{ width: !isDesktopScreen ? '25px' : '13px', height: !isDesktopScreen ? '25px' : '13px' }} 
                              src={!isDesktopScreen ? DeleteIconMobile : TrashIcon} 
                              alt="TrashIcon" 
                            />
                          </IconButton>
                        </td>
                      </tr>

                      <tr>
                        <td className="p0 divider" colSpan="6">
                          <hr />
                        </td>
                      </tr>
                    </>
                  )
                })}
              </>
            ) : null}

            <tr>
              <td className="subtitle pr0">
                <Autocomplete
                  key={selectedProduct}
                  options={productOptions}
                  getOptionLabel={(option) => option?.description || option}
                  className="autocompleteSmall mr12"
                  size="small"
                  value={selectedProduct}
                  inputValue={selectedProductInputValue}
                  onInputChange={(_, value) => {
                    getMoreOptions(value);
                    setSelectedProductInputValue(value);
                  }}
                  onFocus={() => {
                    getMoreOptions()
                  }}
                  onChange={(_, value) => {
                    if (value) {
                      const formattedProduct = {
                        ...value,
                        typeEvent: "DISCARD"
                      }
                      
                      setProducts([
                        ...products,
                        formattedProduct
                      ])

                      setSelectedProduct("");
                      setSelectedProductInputValue("")
                    }
                  }}
                  getOptionDisabled={(option) => 
                    products?.map(el => el?.id).includes(option?.id)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id={params.id}
                      type="text"
                      name="Products"
                      variant="outlined"
                      placeholder="PRODUTOS..."
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  )}
                  renderOption={(params) => (
                    <Typography style={{ fontSize: '12px', fontFamily: 'Lato' }}>
                      {params.description}
                    </Typography>
                  )}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div className="actionButtons dFlex justifyEnd alignCenter w100 mt16 pr16 pl16">
          <Button
            className="defaultButton backButton mr10"
            design="contained"
            label={!isDesktopScreen ? 'VOLTAR' : 'Voltar'}
            onClick={() => {
              handleClose()
            }}
          />

          <Button
            className={`${!isDesktopScreen && 'spanChildUppercase'} defaultButton submitButton`}
            design="contained"
            disabled={!products?.length || products?.some(el => !el?.discard?.discardId || !el?.quantity)}
            label={callSettings.loading ? 'Salvando...' : 'Salvar'}
            onClick={() => handleSubmit()}
          />
        </div>

        <CommonAlert
          open={showAlert}
          autoHideDuration={4000}
          onClose={() => {
            setShowAlert(false);
            setMessage(null);
            setSeverity(null)
            setStatusCode(null)
            handleClose()
          }}
          severity={severity}
          messagePersonal={message}
          indexMessage={message}
          statusCode={statusCode}
        />
      </DialogContent>
    </Dialog>
  );
}

export default WriteOffReleases;
